export default {
	teslaAuthStatus: {},
	teslaVehicles: [],
  	departureSchedules: [],	
  	subscriptions: {},
	preferences: {},
  	departureCalendars: [],	
	session: !!sessionStorage.jwt
}


// WEBPACK FOOTER //
// ./src/reducers/initialState.js